export default "__VITE_ASSET__A4V8EC0B__"